import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'treeFilter'
})
export class TreeFilterPipe implements PipeTransform {
  transform(items: any, searchText?: any): any {
    console.log('tree filter will run')
    if (!items) return null;
    if (!searchText) return items;
    searchText = searchText.toLowerCase().trim();
    function loop (_items:any) {
      return _items.filter((item:any)=>{
        if(item.tcm_type == 'file'){
          if(item.text.toLowerCase().includes(searchText)) {
            let r = new RegExp(searchText, 'ig');
            item.text = item.text.replace(r, (a:any)=>{
              return '<span style="color:#2478c7">' + a + '</span>';
            });
            return true;
          }
        } else {
          item.children = loop(item.children);
          if(item.children.length > 0) return true;
        }
      })
    }
    let tmpItems = loop(JSON.parse(JSON.stringify(items)));  
    return tmpItems;
  }
}



// WEBPACK FOOTER //
// ./public/app/_pipes/tree-filter.pipe.ts